module.exports = __webpack_public_path__ + "img/tayun-night.5554ec6e.png";